<template>
  <div class="flex w-full h-full mx-auto p-6">
    <div
      class="bg-white shadow-lg rounded-lg w-2/6 mx-4 pt-4 px-4 overflow-hidden"
      style="padding-bottom: 18rem"
    >
      <div class="flex items-center pb-4">
        <h3
          class="flex items-center font-bold text-gray-900 px-2 py-2 leading-tight tracking-wider"
        >
          Lista de denuncias
          <span
            class="rounded-full ml-2 border-solid border-2 border-gray-300 px-3 py-1 bg-gray-100"
          >{{filteredComplaints.length}}</span>
        </h3>
        <button class="border-2 rounded border-gray-700" @click="changeFormOrder">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>

        <div class="border-2 rounded border-gray-700 cursor-pointer p-1 ml-2">
          <download-excel :before-generate = "startDownload" :data="complaints" :fields="json_fields" name="Denuncias.xls">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="black"
              width="18px"
              height="18px"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path
                d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2v9.67z"
              />
            </svg>
          </download-excel>
        </div>
      </div>
      <input
        type="text"
        v-model="search"
        placeholder="Búsqueda de denuncias"
        class="w-full appearance-none border rounded py-2 px-3 mb-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
      />
      <div class="w-full">
        <div class="w-full relative">
          <select
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            name="status"
            id="status"
            v-model="categoryFilter"
          >
            <option selected value="-1">Todos</option>
            <template v-for="category in complaintCategories">
              <option :key="category.id" :value="category.id">{{category.name}}</option>
            </template>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
      <div class="w-full flex pt-4">
        <button
          v-on:click="statusFilterComplaints = 'all', filteredComplaints"
          class="w-1/2 hover:bg-cdmx-blue-light font-semibold hover:text-white py-2 px-4 border-t border-l border-b border-cdmx-blue-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterComplaints === 'all' ? 'border-transparent bg-cdmx-blue-light text-white' : 'bg-transparent text-cdmx-blue-dark']"
        >Todos {{complaints.length}}</button>
        <button
          v-on:click="statusFilterComplaints = 'open', filteredComplaints"
          class="w-1/2 hover:bg-cdmx-blue-light font-semibold hover:text-white py-2 px-4 border border-cdmx-blue-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterComplaints === 'open' ? 'border-transparent bg-cdmx-blue-light text-white' : 'bg-transparent text-cdmx-blue-dark']"
        >Abiertas {{filteredComplaintsByOpen.length}}</button>
      </div>
      <div class="w-full flex pb-2">
        <button
          v-on:click="statusFilterComplaints = 'pending', filteredComplaints"
          class="w-1/2 hover:bg-cdmx-blue-light font-semibold hover:text-white py-2 px-4 border-l border-r border-b border-cdmx-blue-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterComplaints === 'pending' ? 'border-transparent bg-cdmx-blue-light text-white' : 'bg-transparent text-cdmx-blue-dark']"
        >Pendientes {{filteredComplaintsByPending.length}}</button>
        <button
          v-on:click="statusFilterComplaints = 'close', filteredComplaints"
          class="w-1/2 hover:bg-cdmx-blue-light font-semibold hover:text-white py-2 px-4 border-r border-b border-cdmx-blue-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterComplaints === 'close' ? 'border-transparent bg-cdmx-blue-light text-white' : 'bg-transparent text-cdmx-blue-dark']"
        >Cerradas {{filteredComplaintsByClosed.length}}</button>
      </div>
      <div class="h-full overflow-auto">
        <div
          v-for="event in filteredComplaints"
          :key="event.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{'bg-cdmx-blue-light': event.id === currentComplaint.id}"
          @click="selectComplaint(event)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            :class="[event.id === currentComplaint.id ? 'text-gray-100' : 'text-gray-900']"
            class="h-20 w-20 group-hover:text-gray-900 text-gray-100"
            stroke-width="1.5"
            v-if="event.file_type == 'image/jpeg'"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <polyline points="21 15 16 10 5 21" />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke="currentColor"
            :class="[event.id === currentComplaint.id ? 'text-gray-100' : 'text-gray-900']"
            class="h-20 w-20 group-hover:text-gray-900 text-gray-100"
            fill="none"
            stroke-width="1.5"
            v-if="event.file_type == 'video/mp4'"
          >
            <polygon points="23 7 16 12 23 17 23 7" />
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke="currentColor"
            :class="[event.id === currentComplaint.id ? 'text-gray-100' : 'text-gray-900']"
            class="h-20 w-20 group-hover:text-gray-900 text-gray-100"
            fill="none"
            stroke-width="1.5"
            v-if="event.file_type == 'audio/mpeg'"
          >
            <path d="M9 18V5l12-2v13" />
            <circle cx="6" cy="18" r="3" />
            <circle cx="18" cy="16" r="3" />
          </svg>

          <div class="flex flex-col ml-2">
            <span
              :class="[event.id === currentComplaint.id ? 'text-gray-100' : 'text-gray-900']"
              class="group-hover:text-gray-900"
            >F-{{event.id}}</span>
            <span
              :class="[event.id === currentComplaint.id ? 'text-gray-100' : 'text-gray-900']"
              class="group-hover:text-gray-900"
            >{{ event.date | moment('DD/MM/YYYY hh:mm A')}}</span>
            <span
              :class="[event.id === currentComplaint.id ? 'text-gray-300' : 'text-gray-700']"
              class="text-sm group-hover:text-gray-700"
            >{{ event.category_name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden">
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full">
          <div class="w-full pb-2 text-right">
            <button
              class="bg-transparent hover:bg-red-500 text-cdmx-red font-semibold hover:text-white py-2 px-4 mx-1 border border-cdmx-red hover:border-transparent rounded"
              @click="showingConfirm = true;"
            >Eliminar</button>
            <button
              v-if="currentComplaint.status == 'en proceso'"
              class="bg-transparent hover:bg-cdmx-blue-light text-cdmx-blue-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-cdmx-blue-dark hover:border-transparent rounded"
              @click="sendEmail(currentComplaint)"
            >Enviar</button>
          </div>
          <div class="w-full pb-2 text-right"></div>
          <div class="flex">
            <div class="h-80 w-full">
              <l-map
                ref="map"
                class="h-full w-full z-0"
                :zoom="zoom"
                :minZoom="11"
                :center="center"
                :options="{zoomControl: false}"
                @ready="onMapReady"
              >
                <l-geo-json :geojson="polygon" :options-style="geoStyle" />
                <l-marker :lat-lng="center" :visible="showMarker"></l-marker>
              </l-map>
            </div>
          </div>

          <div class="flex py-2">
            <div class="w-full px-4 text-left">
              <div class="font-bold tracking-wide text-lg text-gray-900">
                Denuncia
                <span
                  v-if="currentComplaint.status == 'no atendida'"
                  class="text-orange-500"
                >(Abierta)</span>
                <span
                  v-if="currentComplaint.status == 'en proceso'"
                  class="text-orange-500"
                >(Pendiente)</span>
                <span v-if="currentComplaint.status == 'atendida'" class="text-orange-500">(Cerrada)</span>
              </div>
              <div class="text-sm text-gray-700" v-html="removeLineBreaks(currentComplaint.text)"></div>
            </div>
          </div>
          <div class="relative flex flex-col text-left px-4">
            <span class="font-bold text-gray-700">Fecha de denuncia:</span>
            <div v-html="formatDate(currentComplaint.date)"></div>
            <span class="font-bold text-gray-700">Fecha de imagen/video:</span>
            <div
              v-html="dateMediaFile(currentComplaint.media_metadata, currentComplaint.file_type)"
            ></div>
            <span
              v-if="datesDontMatch(currentComplaint.date, currentComplaint.media_metadata, currentComplaint.file_type) == true"
              class="text-cdmx-red italic"
            >Las fechas de denuncia y de archivo de media no coinciden</span>
            <button
              class="absolute top-0 right-0 border-2 rounded border-gray-700"
              @click="openMetadataModal()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                enable-background="new 0 0 24 24"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <g>
                  <rect fill="none" height="24" width="24" />
                  <path
                    d="M19,7H9C7.9,7,7,7.9,7,9v10c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V9C21,7.9,20.1,7,19,7z M19,9v2H9V9H19z M13,15v-2h2v2H13z M15,17v2h-2v-2H15z M11,15H9v-2h2V15z M17,13h2v2h-2V13z M9,17h2v2H9V17z M17,19v-2h2v2H17z M6,17H5c-1.1,0-2-0.9-2-2V5 c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v1h-2V5H5v10h1V17z"
                  />
                </g>
              </svg>
            </button>
          </div>

          <div
            v-if="currentComplaint.file_type == 'video/mp4'"
            class="flex justify-center py-2 w-full"
          >
            <video
              :src="currentComplaint.url"
              width="640"
              height="480"
              controls
              controlslist="nodownload"
            />
          </div>
          <div
            v-if="currentComplaint.file_type == 'image/jpeg'"
            class="flex justify-center py-2 w-8/12 mx-auto"
          >
          <v-lazy-image :src="currentComplaint.url" />
            <!-- <img :src="currentComplaint.url" width="640" height="480" /> -->
          </div>
          <div
            v-if="currentComplaint.file_type == 'audio/mpeg'"
            class="flex justify-center py-2 w-full"
          ><audio :src="currentComplaint.url" type=”audio/mp3″ controls controlsList="nodownload" /></div>
          <div v-if="currentComplaint.status != 'atendida'" class="flex justify-center py-2 w-full">
            <form class="w-1/2" id="complaintReportForm" @submit.prevent>
              <span class="font-bold">Reporte</span>
              <div class="flex py-2 relative mb-3" v-if="currentComplaint.status == 'no atendida'">
                <select
                  v-model="selectStatusComplaint"
                  name="statusComplaint"
                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                >
                  <option
                    v-if="currentComplaint.status == 'no atendida'"
                    value="en proceso"
                  >Pendiente</option>
                  <option value="atendida">Cerrado</option>
                </select>
                <div
                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                >
                  <svg
                    class="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                    />
                  </svg>
                </div>
              </div>
              <p
                v-if="errors.select"
                class="text-red-500 text-xs italic"
              >Asigne un estado a la denuncia.</p>
              <div
                v-if="selectStatusComplaint == 'atendida' || currentComplaint.status == 'en proceso'"
                class="flex py-2"
              >
                <textarea
                  name="reply"
                  class="w-full shadow-inner p-4 border-0"
                  placeholder="Ingrese el reporte correspondiente"
                  rows="6"
                ></textarea>
              </div>
              <div class="flex w-full justify-end">
                <!-- <button
                  v-if="selectStatusComplaint == ''"
                  class="bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  v-on:click="updateComplaint"
                >Actualizar</button>-->
                <button
                  v-if="selectStatusComplaint == 'en proceso'"
                  class="bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  v-on:click="updateComplaint"
                >Actualizar y enviar correo electrónico</button>
                <button
                  v-if="selectStatusComplaint == 'atendida' || currentComplaint.status == 'en proceso'"
                  class="bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  v-on:click="updateComplaint"
                >Cerrar la denuncia</button>
              </div>
            </form>
          </div>

          <div
            class="flex py-2"
            v-if="selectStatusComplaint == 'en proceso' || currentComplaint.status == 'en proceso'"
          >
            <div class="w-full px-4 text-left">
              <div class="font-bold tracking-wide text-lg text-gray-900">Correos electrónicos</div>
              <div class="w-full px-2 py-4">
                <span
                  v-for="(email, index) in currentEmails"
                  :key="index"
                  class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2"
                >{{email}}</span>
              </div>
            </div>
          </div>

          <div v-if="currentComplaint.status == 'atendida'" class="flex py-2">
            <div class="w-full px-4 text-left">
              <div class="font-bold tracking-wide text-lg text-gray-900">REPORTE</div>
            </div>
          </div>
          <div v-if="currentComplaint.status == 'atendida'" class="flex py-2">
            <textarea class="w-full shadow-inner p-4 border-0" rows="6" readonly>{{currentComplaint.reply}}</textarea>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Denuncia actualizada</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{errors.codeError}}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Desea eliminar esta denuncia?</div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="deleteComplaint()"
        >Eliminar</button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirm = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDelete">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Eliminado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDelete = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <metadata-modal
      :metadata="currentComplaint.media_metadata"
      :filetype="currentComplaint.file_type"
      :showing="showingMetadata"
      @close="showingMetadata = false"
    ></metadata-modal>
  </div>
</template>

<script>
import { backend_url } from "../config/url.config.ts";
import AlertDialog from "./AlertDialog";
import moment from "moment";
import polygon from "../assets/polygonChapp.json";
import L from "leaflet";
import { LMap, LMarker, LGeoJson } from "vue2-leaflet";
import * as esri from "esri-leaflet";
import { Icon } from "leaflet";
import MetadataModal from "./MetadataModal";

export default {
  name: "complaints-list",
  data() {
    return {
      showingConfirm: false,
      showingSuccessDelete: false,
      email: localStorage.getItem("email"),
      json_fields: {
        Categoria: "category_name",
        Texto: "text",
        Estado: {
          field: "status",
          callback: value => {
            let status = "";
            switch (value) {
              case "no atendida":
                status = "Abierta";
                break;
              case "en proceso":
                status = "Pendiente";
                break;
              case "atendida":
                status = "Cerrada";
                break;
              default:
                status = "No categorizado";
                break;
            }
            return status;
          }
        },
        Url: "url",
        Date: {
          field: "date",
          callback: value => {
            return moment(value).format("DD/MM/YYYY hh:mm A");
          }
        },
        lat: "lat",
        lon: "lon"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      complaints: [],
      search: "",
      currentEmails: null,
      statusFilterComplaints: "all",
      currentComplaint: {},
      selectStatusComplaint: "",
      showEventModal: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      complaintCategories: [],
      categoryFilter: "-1",
      showingSuccess: false,
      errors: {
        select: false,
        codeError: "Ha ocurrido un error"
      },
      formOrder: "downward",
      polygon: polygon,
      zoom: 14,
      center: [19.412257, -99.200871],
      showMarker: false,
      geoStyle: {
        color: "#cb2833",
        fill: false
      },
      showingMetadata: false
    };
  },
  components: {
    LMap,
    LMarker,
    LGeoJson,
    AlertDialog,
    MetadataModal
  },
  created() {
    let that = this;
/*     this.$socket.$subscribe("newComplaintToMonitor", () => {
      if (that.currentComplaint != null) {
        that.fetchComplaintsBySocket();
      }
    });

    this.$socket.$subscribe("updateCategoryComplaintsToMonitor", () => {
      if (that.currentComplaint != null) {
        that.fetchComplaints();
      }
    });

    this.$socket.$subscribe("updateComplaintToMonitor", data => {
      if (that.email != data.email) {
        if (that.currentComplaint != null) {
          if (data.complaint_id == that.currentComplaint.id) {
            that.fetchComplaints();
          } else {
            that.fetchComplaintsBySocket();
          }
        }
      }
    }); */
  },
  mounted() {
    this.fetchComplaints();
    this.fetchComplaintCategories();
  },
  methods: {
    startDownload(){
      this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
          "module": "Denuncias", 
          "action": "Descarga de información de las denuncias", 
          "observation": 'Información de las denuncias',
          "email": localStorage.getItem("email")
        },
        this.config
      )
      .then(response => {
        //console.log(response)
      })
      .catch(error => {
        //console.log(error)
      });
    },
    onMapReady: function() {
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        esri.basemapLayer("Topographic").addTo(map);
      });
    },
    fetchComplaintsBySocket() {
      this.axios
        .post(backend_url + "/visitors/complaintList", {}, this.config)
        .then(response => {
          this.complaints = response.data.categories;
          this.complaints.forEach(category => {
            category.url = backend_url + "/" + category.url;
            if (category.id == this.currentComplaint.id) {
              this.currentComplaint = category;
            }
          });
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.showingError = false;
        });
    },
    fetchComplaints() {
      this.axios
        .post(backend_url + "/visitors/complaintList", {}, this.config)
        .then(response => {
          this.complaints = response.data.categories;
          response.data.categories.forEach(category => {
            category.url = backend_url + "/" + category.url;
          });
          this.currentComplaint = this.filteredComplaints[0];
          if (
            this.currentComplaint.lat !== null &&
            this.currentComplaint.lon !== null
          ) {
            this.center = [
              this.currentComplaint.lat,
              this.currentComplaint.lon
            ];
            this.showMarker = true;
          } else {
            this.showMarker = false;
          }
          this.selectStatusComplaint = "";
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.showingError = false;
        });
    },
    selectComplaint(event) {
      this.selectStatusComplaint = "";
      this.currentComplaint = event;
      if (event.lat !== null && event.lon !== null) {
        this.center = [event.lat, event.lon];
        this.showMarker = true;
      } else {
        this.showMarker = false;
      }
      this.complaintCategories.forEach(complaint => {
        if (complaint.id == event.category_id) {
          this.currentEmails = complaint.email.split(",");
        }
      });

      this.errors = {
        select: false,
        codeError: "Ha ocurrido un error"
      };
    },
    removeLineBreaks(description) {
      if (description === undefined || description === null) {
        return "";
      } else {
        return description.replace(/(?:\\r\\n)/g, "<br />");
      }
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY hh:mm A");

      /* 	   let dateComplaint = new Date(date)
		var monthNames = [
		  "Enero", "Febrero", "Marzo",
		  "Abril", "Mayo", "Junio", "Julio",
		  "Agosto", "Septiembre", "Octubre",
		  "Noviembre", "Diciembre"
		];

		var day = dateComplaint.getDate();
		var monthIndex = dateComplaint.getMonth();
		var year = dateComplaint.getFullYear();

		return day + ' ' + monthNames[monthIndex] + ' ' + year;*/
    },
    formatExitDate(exifDate, mediaType) {
      let str = exifDate.split(" ");
      let dateStr = str[0].replace(/:/g, "-");
      let properDateStr = dateStr + " " + str[1];
      let dateExif = new Date(properDateStr);
      /*	  if(mediaType == "image")
		return moment(dateExif).format("DD/MM/YYYY hh:mm A");	*/
      if (mediaType == "video") {
        dateExif.setHours(dateExif.getHours() - 5); // corrige la horas si es video ???
      }
      return moment(dateExif).format("DD/MM/YYYY hh:mm A");
    },

    dateMediaFile(metadata, filetype) {
      //console.log(metadata)
      if (metadata != null) {
        switch (filetype) {
          case "image/jpeg":
            if (metadata.hasOwnProperty("createDate")) {
              //return metadata.modifyDate
              //console.log(metadata.createDate)
              return this.formatExitDate(metadata.createDate, "image");
            } else if (metadata.hasOwnProperty("modifyDate")) {
              //return metadata.modifyDate
              //console.log(metadata.modifyDate)
              return this.formatExitDate(metadata.modifyDate, "image");
            } else {
              //return "Fecha de la imagen no disponible (esto puede ser porque la imagen ha sido modificada u obtenida de internet)"
              return "Fecha de la imagen no disponible";
            }

            break;
          case "video/mp4":
            if (metadata.hasOwnProperty("mediaCreateDate")) {
              //return metadata.modifyDate
              //console.log(metadata.mediaCreateDate)
              return this.formatExitDate(metadata.mediaCreateDate, "video");
            } else if (metadata.hasOwnProperty("mediaModifyDate", "video")) {
              return this.formatExitDate(metadata.mediaModifyDate, "video");
            } else {
              //return "Fecha del video no disponible (esto puede ser porque el video ha sido modificado u obtenido de internet)"
              return "Fecha del video no disponible";
            }

            break;
          default:
            break;
        }
      } else {
        //return "Fecha de media no disponible (esto puede ser porque es modificado u obtenido de internet)"
        return "Fecha de media no disponible";
      }

      //return moment(date).format("DD/MM/YYYY hh:mm A");
    },
    mediaMetadata(metadata, filetype) {
      if (metadata == null) {
        switch (filetype) {
          case "image/jpeg":
            return "Metadatos de imagen no disponible";
            break;
          case "video/mp4":
            return "Metadatos de video no disponible";
            break;
          default:
            return "Metadatos de media no disponible";
            break;
        }
      } else {
        return JSON.stringify(metadata, null, 4); // Indented 4 spaces)
      }
    },

    datesDontMatch(complaintDate, ComplaintMetadata, filetype) {
      if (ComplaintMetadata != null) {
        let fechaDenuncia = this.formatDate(complaintDate);
        let fechaMedia = this.dateMediaFile(ComplaintMetadata, filetype);

        //console.log(fechaDenuncia)
        //console.log(fechaMedia)

        let fechaDenunciaArray = fechaDenuncia.split(" "); //separa fecha y hora
        let fechaMediaArray = fechaMedia.split(" ");

        if (fechaDenunciaArray[0] != fechaMediaArray[0]) {
          //compara sólo fecha
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    updateComplaint(complaint) {
      const form = document.getElementById("complaintReportForm");
      const complaintData = new FormData(form);
      let validForm = false;
      let status = "";
      if (this.currentComplaint.status == "en proceso") {
        status = "atendida";
        validForm = true;
      } else {
        validForm = this.checkFormUpdateComplaint(complaintData);
        status = complaintData.get("statusComplaint");
      }
      if (validForm) {
        const reply = complaintData.get("reply");

        this.axios
          .post(
            backend_url + "/api/notifications/complaint/",
            {
              status: status,
              reply: reply,
              complaint_id: this.currentComplaint.id,
              email: this.email
            },
            this.config
          )
          .then(response => {
            let category = this.changeLabelStatus(status);
            let current_category = this.changeLabelStatus(this.currentComplaint.status);
            return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
                "module": "Denuncias", 
                "action": "Cambio de estado de denuncia.", 
                "observation": `${current_category} a ${category} de la denuncia ${this.currentComplaint.id}`,
                "email": localStorage.getItem("email")
              },
              this.config
            )
          })
          .then(response => {
            this.currentComplaint.status = status;
            this.currentComplaint.reply = reply;
            this.selectStatusComplaint = "";
            if (this.selectStatusComplaint == "en proceso") {
              this.sendEmail(this.currentComplaint);
            }
          })
          .catch(error => {
            console.error(error.response);
            if (error.response.status == 400 || error.response.status == 401) {
              if (
                error.response.data.name === "TokenExpiredError" ||
                error.response.data.name === "InvalidTokenError" ||
                error.response.data.name === "JsonWebTokenError"
              ) {
                this.$router.push({ path: "/login" });
              }
            }
            this.showingError = true;
            this.errors.codeError =
              "Hubo un error con la actualización de la denuncia";
          });
      }
    },
    fetchComplaintCategories() {
      this.axios
        .post(backend_url + "/visitors/complaintCategories", {}, this.config)
        .then(response => {
          this.complaintCategories = response.data.categories;
        })
        .catch(error => {
          console.error(error.response);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    sendEmail(complaint) {
      this.axios
        .post(
          backend_url + "/visitors/complaint/sendEmail",
          {
            id: complaint.id,
            category_id: complaint.category_id,
            url: complaint.url,
            file_type: complaint.file_type
          },
          this.config
        )
        .then(response => {
          return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
              "module": "Denuncias", 
              "action": "Envío de evidencia", 
              "observation": `${this.currentComplaint.id}`,
              "email": localStorage.getItem("email")
            },
            this.config
          )
        })
        .then(response => {
          this.showingSuccess = true;
          console.log("SEND");
        })
        .catch(error => {
          this.showingError = true;
          this.errors.codeError = "Hubo un error con el envío de la evidencia";
          console.error(error.response);
        });
    },

    deleteComplaint() {
      this.axios
        .delete(
          backend_url +
            "/visitors/complaint/remove/" +
            this.currentComplaint.id,
          this.config
        )
        .then(response => {
          this.showingConfirm = false;
          this.showingSuccessDelete = true;
          this.fetchComplaints();
        })
        .catch(error => {
          console.error(error.response);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    checkFormUpdateComplaint: function(data) {
      if (data.get("statusComplaint") === null) {
        this.errors.select = true;
      } else {
        this.errors.select = false;
      }

      if (this.errors.select) {
        return false;
      }

      return true;
    },
    changeFormOrder() {
      if (this.formOrder === "upward") {
        this.formOrder = "downward";
      } else {
        this.formOrder = "upward";
      }
    },
    openMetadataModal() {
      this.showingMetadata = true;
    },
    changeLabelStatus(status){
      let category = "";

      switch(status){
        case 'no atendida':
          category = "Abierta";
          break;
        case 'en proceso':
          category = "Pendiente";
          break;
        case 'atendida':
          category = "Cerrada";
          break;
        default:
          category = "no categorizado";
          break;
      }
      return category
    }
  },
  computed: {
    filteredComplaints() {
      return this.complaints
        .filter(complaint => {
          let date = moment(complaint.date).format("DD/MM/YYYY hh:mm A");
          switch (this.statusFilterComplaints) {
            case "all":
              return (
                (date.toLowerCase().includes(this.search.toLowerCase()) ||
                  complaint.id.toLowerCase().includes(this.search.toLowerCase()) ||
                  complaint.category_name
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                (this.categoryFilter === "-1" ||
                  complaint.category_id === this.categoryFilter)
              );
            case "open":
              return (
                (date.toLowerCase().includes(this.search.toLowerCase()) ||
                complaint.id
                    .toLowerCase()
                    .includes(this.search.toLowerCase()) ||
                  complaint.category_name
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                complaint.status == "no atendida" &&
                (this.categoryFilter === "-1" ||
                  complaint.category_id === this.categoryFilter)
              );
            case "pending":
              return (
                (date.toLowerCase().includes(this.search.toLowerCase()) ||
                complaint.id
                    .toLowerCase()
                    .includes(this.search.toLowerCase()) ||
                  complaint.category_name
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                complaint.status == "en proceso" &&
                (this.categoryFilter === "-1" ||
                  complaint.category_id === this.categoryFilter)
              );
            case "close":
              return (
                (date.toLowerCase().includes(this.search.toLowerCase()) ||
                  complaint.id .toLowerCase().includes(this.search.toLowerCase()) ||
                  complaint.category_name
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                complaint.status == "atendida" &&
                (this.categoryFilter === "-1" ||
                  complaint.category_id === this.categoryFilter)
              );
            default:
              break;
          }
        })
        .sort((a, b) => {
          if (this.formOrder === "upward") {
            return new Date(a.date) - new Date(b.date);
          } else {
            return new Date(b.date) - new Date(a.date);
          }
        });
    },
    filteredComplaintsByOpen() {
      return this.complaints.filter(complaint => {
        let date = moment(complaint.date).format("DD/MM/YYYY hh:mm A");
        return complaint.status == "no atendida";
      });
    },
    filteredComplaintsByPending() {
      return this.complaints.filter(complaint => {
        let date = moment(complaint.date).format("DD/MM/YYYY hh:mm A");
        return complaint.status == "en proceso";
      });
    },
    filteredComplaintsByClosed() {
      return this.complaints.filter(complaint => {
        let date = moment(complaint.date).format("DD/MM/YYYY hh:mm A");
        return complaint.status == "atendida";
      });
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
